"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__BaseTooltipLink = __BaseTooltipLink;
var _react = _interopRequireDefault(require("react"));
var _mdiMaterialUi = require("mdi-material-ui");
var _classnames = _interopRequireDefault(require("classnames"));
var _styles = require("@material-ui/styles");
var _Theme = _interopRequireDefault(require("../../Theme"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = (0, _styles.makeStyles)({
  withExternalIcon: {
    display: 'inline-flex',
    alignItems: 'center'
  },
  disableStyles: {
    textDecoration: 'none',
    color: 'inherit'
  },
  externalIcon: {
    fontSize: _Theme.default.typography.pxToRem(16),
    marginLeft: _Theme.default.spacing(0.5)
  }
});
function __BaseTooltipLink(_ref) {
  var children = _ref.children,
    classes = _ref.classes,
    link = _ref.link,
    showExternalIcon = _ref.showExternalIcon,
    linkTopicDataId = _ref.linkTopicDataId;
  var linkClasses = useStyles();
  var allClasses = (0, _classnames.default)(classes, _defineProperty({}, linkClasses.withExternalIcon, showExternalIcon));
  return /*#__PURE__*/_react.default.createElement("a", {
    href: link,
    className: allClasses,
    "data-cy": "tooltip-link",
    target: "__blank",
    "data-id": linkTopicDataId
  }, children, showExternalIcon && /*#__PURE__*/_react.default.createElement(_mdiMaterialUi.OpenInNew, {
    fontSize: "inherit",
    className: linkClasses.externalIcon
  }));
}